// extracted by mini-css-extract-plugin
export default {"blue":"Bar_blue__GcJfI","green":"Bar_green__YWMRo"};